import { createFeatureSelector } from '@ngrx/store';

export const locationsFiltersState = createFeatureSelector<OLO.State, OLO.State.LocationsFilters>('locationsFilters');
